/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const ReviewAndConfirmMessages = defineMessages({
  title: {
    id: 'Segment.ReviewAndConfirmMessages.title',
    defaultMessage: 'Review & Confirm Segment Integration'
  },
  description: {
    id: 'Segment.ReviewAndConfirmMessages.description',
    defaultMessage: 'These events can be edited in the future.'
  },
  environment: {
    id: 'Segment.ReviewAndConfirmMessages.environment',
    defaultMessage: 'Environment'
  },
  tooltip: {
    id: 'Segment.ReviewAndConfirmMessages.tooltip',
    defaultMessage:
      'Assistant will share events from this environment with Segment.'
  },
  draftEnvironment: {
    id: 'Segment.ReviewAndConfirmMessages.draftEnvironment',
    defaultMessage: 'Draft Environment'
  },
  liveEnvironment: {
    id: 'Segment.ReviewAndConfirmMessages.liveEnvironment',
    defaultMessage: 'Live Environment'
  },
  environmentName: {
    id: 'Segment.ReviewAndConfirmMessages.environmentName',
    defaultMessage: '{envName} Environment'
  },
  eventSent: {
    id: 'Segment.ReviewAndConfirmMessages.eventSent',
    defaultMessage: 'Events sent to Segment'
  }
});
